import classNames from 'classnames';

export const buildClassNamesForTextDisplay = ({ stackSubText }) => {
  const textWrapperClassName = classNames({
    'flex-col': stackSubText,
    'text-left': stackSubText,
    flex: !stackSubText,
    'justify-between': !stackSubText,
  });

  const displayTextClassName = classNames('pr-2', 'text-gray-800', {
    'inline-flex': !stackSubText,
  });

  const subTextClassName = classNames('font-normal', 'text-gray-500', {
    'pr-2': stackSubText,
    'inline-flex': !stackSubText,
  });

  return { displayTextClassName, subTextClassName, textWrapperClassName };
};
